import { Component, inject, Input, OnInit } from '@angular/core';
import { StateBodyCorporate } from '../../../models/body-corporate.model';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import {Roles, ROLES_MESSAGE_MAP} from "../../../../core/constants/roles.enum";
import { Attachment, DocumentType } from '../../../models/attachment.model';
import { AttachmentPreviewManager } from '../../../managers/attachment-preview.manager';
import { RegistrationManager } from '../../../../features/application/registration/managers/registration.manager';
import { AttachmentService } from '../../../services/attachment.service';

@Component({
    selector: 'app-payment-body-corporate-modal',
    templateUrl: './payment-body-corporate-modal.component.html',
    styleUrls: ['./payment-body-corporate-modal.component.scss'],
    standalone: false
})
export class PaymentBodyCorporateModalComponent implements OnInit {

  isVisible: boolean = true;

  //@ts-ignore
  @Input() bodycorp: StateBodyCorporate;
  @Input() isPayer: boolean = false;
  @Input() isRecipient: boolean = false;
  excludedRoles: Roles[] = [Roles.PAYR, Roles.PCNT, Roles.RCPT];

  certificate: Attachment | null = null;

  constructor(public modal: NzModalRef<PaymentBodyCorporateModalComponent>, 
    private attachmentService: AttachmentService,
    private attachmentPreviewManager: AttachmentPreviewManager) {

  }

  ngOnInit(): void {
    this.bodycorp = this.nzModalData.bodycorp;
    this.isPayer = this.nzModalData.isPayer;
    this.isRecipient = this.nzModalData.isRecipient;
    this.certificate = this.attachmentService.attachments.find(i => i.documentType == DocumentType.INCORPORATION_CERTIFICATE_DOCUMENT && i.documentId == this.bodycorp.incorporationCertificateDocIds[0] || null) || null;
  }

  public readonly nzModalData: any = inject(NZ_MODAL_DATA);

  mapRoleToText(role: string): string {
    return ROLES_MESSAGE_MAP.get(role) || role;
  }

  getFilteredJobTitlesBodyCorporated(bodyCorp: StateBodyCorporate): Roles[] {
    return bodyCorp.jobTitles.map(role => role.titleCode as Roles).filter(role => !this.excludedRoles.includes(role));
  }

  previewFile(att: Attachment) {
    this.attachmentPreviewManager.openPreview({ fileId: att.documentId, fileName: att.fileName, applicationId: att.backOfficeApplicationId});
  }
}
